import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Table from '../Table';

var Auth = new AuthService();

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.user = Auth.getProfile();
		this.actions = this.actions = <a href="/dashboard" className="pp-text-button">Back to Dashboard</a>;
		this.getCSVDownload = this.getCSVDownload.bind(this);
		this.convertToCSV = this.convertToCSV.bind(this);
		this.downloadCSV = this.downloadCSV.bind(this);

		this.state = {
			table: {
				tableHeading: [],
				tableBody: []
			},
		};

		this.Auth.fetch('/prediction/stats')
		.then((result) => {
			let header = ['Date', 'Created', 'Configured', 'Approved', 'Published', ''],
				months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				rows = [];
			if (result.success === true) {
				console.log(result);

				for (let year in result.report_stats) {
					for (let month in result.report_stats[year]) {
						let created = result.report_stats[year][month].created || 0,
							configured = result.report_stats[year][month].configured || 0,
							approved = result.report_stats[year][month].approved || 0,
							published = result.report_stats[year][month].published || 0,
							download = (published > 0) ? <button onClick={this.getCSVDownload} data-year={year} data-month={month} className="pp-text-button">Download</button> : '';

						rows.push( [ months[month] + ' ' + year, created, configured, approved, published, download ] );
					}
				}

				rows.reverse();

				this.setState({
					table: {
						tableHeading: header,
						tableBody: rows
					}
				});
			}
		});
	}

	componentDidMount() {
		// get applications
		this.Auth.fetch("/boat-applications")
		.then(
			(result) => {
				if(result) {
					this.setState({
						applications: result.data
					});
				} else {
					if(result.errors) {
						alert(result.errors.join("\n"));
					}
				}
			},
			(error) => {
				this.setState({
					error
				});
			}
		);
	}

	getCSVDownload(e) {
		let year = e.target.getAttribute('data-year'),
			month = e.target.getAttribute('data-month');

		console.log(e.target);

		this.Auth.fetch('/prediction/stats/' + year + '/' + month)
		.then((result) => {
			if (result.success === true) {
				for (let a = 0; a < result.data.length; a += 1) {
					
					if (result.data[a].boat_application != null) {

						for (let b = 0; b < this.state.applications.length; b += 1) {
							// replace boat application ID with name
							if (this.state.applications[b].boat_app_id == result.data[a].boat_application) {
								result.data[a].boat_application = this.state.applications[b].boat_application_name;

								for (let c = 0; c <  this.state.applications[b].sub_applications.length; c += 1) {
									// replace boat sub application ID with name
									if (this.state.applications[b].sub_applications[c].sub_application_id == result.data[a].boat_sub_application) {
										result.data[a].boat_sub_application = this.state.applications[b].sub_applications[c].sub_application_name;
									}
								}
							}
						}
					}
				}
	  			const csvData = this.convertToCSV(result.data);
	  			this.downloadCSV(csvData, year+'_'+month+'_report_summary.csv');
			}
		});
	}

	convertToCSV(jsonData) {
		const items = jsonData;
		const replacer = (key, value) => value === null ? '' : value;
		const header = Object.keys(items[0]);
		const csv = [
		  header.join(','),
		  ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
		].join('\r\n');
		return csv;
	}
	  
	downloadCSV(csv, filename) {
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
		if (navigator.msSaveBlob) {
		  navigator.msSaveBlob(blob, filename);
		} else {
		  const link = document.createElement('a');
		  if (link.download !== undefined) {
			const url = URL.createObjectURL(blob);
			link.setAttribute('href', url);
			link.setAttribute('download', filename);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		  }
		}
	}

	render() {

		return (
			<Page pageTitle="Report Statistics" pageClass="pp-stats-page" pageActions={this.actions}>
				<div className="stats-content">
					<PageSection
						sectionTitle=""
						sectionActions={""}
					>
					<Table
							tableHeading={this.state.table.tableHeading}
							tableBody={this.state.table.tableBody}
							noResultsMessage={"Loading stats..."}
						/>	
					</PageSection>
				</div>
			</Page>
		);
	}
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/pages/Stats.js